let Api = {
    "QPSTZX_WMFW_FLLIST": "/simple-api/n/qpstzx/wmfw/wmfwflList", //外贸分类
    "QPSTZX_WMFW_FWLIST": "/simple-api/n/qpstzx/wmfw/wmfwsqList", //外贸服务
    "QPSTZX_WMFW_FWZXADD": "/simple-api/n/qpstzx/wmfw/wmfwzxAdd", //新增外贸咨询
    "QPSTZX_PXFW_COURSESTYPELIST": "/simple-api/n/qpstzx/pxfw/coursesTypeList", //课程分类管理
    "QPSTZX_PXFW_COURSESFINDPAGE": "/simple-api/n/qpstzx/pxfw/coursesFindPage", //课程信息列表(分页)
    "QPSTZX_XXPX_TRAINTYPELIST": "/simple-api/n/qpstzx/xxpx/trainTypeList", //培训分类列表
    "QPSTZX_XXPX_TRAINTFINDPAGE": "/simple-api/n/qpstzx/xxpx/trainFindPage", //线下培训列表(分页)
    "QPSTZX_PXFW_PXFWZXADD": "/simple-api/n/qpstzx/pxfw/pxfwzxAdd", //新增培训信息
    "USERGUIDE_FINDNAV_TREE": "/portal-api/n/industryArticleClassMage/findIndustryUserArticleClassMageTree", //查询用户指南分类树加文章
    "USERGUIDE_ARTICLE_FINDINFO": "/portal-api/n/industryArticleMage/findInfo", //文章详细信息
    "USERGUIDE_ARTICLE_FINDLIST": "/portal-api/n/industryArticleMage/findList", //文章列表
    "USERGUIDE_ARTICLE_FINDLISTBYARTICLECLASSID": "/portal-api/n/industryArticleMage/findListByArticleClassId", 
    "USERGUIDE_ARTICLE_FINDONEBYARTICLECLASSID": "/portal-api/n/industryArticleMage/findOneByArticleClassId", 
    "N_CODECBASE64": "/portal-api/n/codecBase64", 







}
module.exports = Api